import { render, staticRenderFns } from "./office.vue?vue&type=template&id=5c9b5c2c&scoped=true&lang=pug"
import script from "./office.vue?vue&type=script&lang=js"
export * from "./office.vue?vue&type=script&lang=js"
import style0 from "./office.vue?vue&type=style&index=0&id=5c9b5c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9b5c2c",
  null
  
)

export default component.exports